<ng-container *ngIf="aside">
	<div class="defaultAside aside-open slide-box-show"
		id="processHolder">
		<a (click)="close()"
			href="javascript:void(0)"
			class="closebtn">
			&times;
		</a>
		<div class="page-header-banner">
			<svg-icon *ngIf="
                !notificationsService.silencedNotices"
				[svgStyle]="{fill:'#fff'}"
				(click)="notificationsService.triggerNotices()"
				class="notif-icon"
				src="assets/images/notif-bell.svg"></svg-icon>
			<svg-icon *ngIf="notificationsService.silencedNotices"
				[svgStyle]="{fill:'#fff'}"
				(click)="notificationsService.triggerNotices()"
				class="notif-icon"
				src="assets/images/notif-bell-off.svg"></svg-icon>
			<h1>Notifications</h1>
		</div>
		<div class="notification-button-container">
			<button (click)="navigateToNotificationList()"
				type="button"
				class="btn btn-primary notification-buttons">
				Notification List
			</button>
			<button *ngIf="displayButton"
				(click)="deleteAll()"
				type="button"
				class="btn btn-primary notification-buttons">
				Clear All
			</button>
		</div>
		<div class="p-4">
			<ng-container *ngFor="let notification of (notifications$ | async)?.data">
				<div *ngIf="showRead || !notification.isRead"
					[ngClass]="{'hover': getNotificationRoute(notification)}"
					(click)="this.navigateByNotificationType(notification)"
					class="card mb-2">
					<div [ngClass]="{'read' : notification.isRead}"
						class="card-body">
						<div class=" d-flex justify-content-between">
							<h5 class="card-title">
								{{notification.subject}}
							</h5>
							<a (click)="delete(notification)"
								class="delete-notification">
								X
							</a>
						</div>
						<p [innerHTML]="notification.content"
							class="card-text"></p>
						<div class=" d-flex justify-content-between">
							<small>
								{{notification.createdAt | date: 'dd MMM yyyy @ HH:mm'}}
							</small>
							<a *ngIf="!notification.isRead"
								(click)="markAsRead(notification, $event)"
								class="mark-as-read">
								<small>Mark as read</small>
							</a>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="!aside">
	<div class="table-responsive">
		<table class="table table-borderless align-middle custom-wrap">
			<thead>
				<tr>
					<th style="width: 180px">Received</th>
					<th>Details</th>
					<th style="width: 120px; text-align: right">Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let notification of (notifications$ | async)?.data"
					[ngClass]="{'read' : notification.isRead}">
					<td>
						{{notification.createdAt.toDate() | date: 'dd MMM yyyy @ HH:mm'}}
					</td>
					<td>
						{{notification.content}}
					</td>
					<td style="text-align: right">
						<a *ngIf="!notification.isRead"
							(click)="markAsRead(notification, $event)"
							class="card-link">
							<small>Mark as read</small>
						</a>
						<a *ngIf="notification.isRead"
							(click)="delete(notification)"
							class="card-link ms-3">
							X
						</a>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-container>
